import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import type { TabItem } from '@/types/main'

export default defineComponent({
  name: 'TabsNav',
  props: {
    selectedTab: {
      type: String,
    },
    items: {
      type: Array as PropType<TabItem[]>,
      required: true,
    },
    // круглый стиль как публикациях, flat - с полоской под табом
    isStyleFlat: {
      type: Boolean,
    },
  },
  emits: ['onTabSelect'],
  setup(_, { emit }) {
    // const selectedTab = ref('')
    const onTabClick = (value: string) => {
      // selectedTab.value = value
      emit('onTabSelect', value)
    }
    return { onTabClick }
  },
})
